import React from 'react';
import { array, bool, func, node, oneOf, string } from 'prop-types';

import useFormId from '../hooks/useFormId';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';

import ActionErrorList from './ActionErrorList';
import CancelButton from './CancelButton';
import ConfirmButton from './ConfirmButton';

import classes from './EsmsDialog.module.css';

const EsmsDialog = ({
    cancelable,
    children,
    className,
    confirmFormId,
    confirmText,
    confirmType,
    disableBackdropClick = false,
    disableEscapeKeyDown = false,
    disabled,
    errors,
    hideButtons,
    imgSrc,
    isLoading,
    isMultiColumn,
    onClose,
    onConfirm,
    onRendered,
    open,
    title
}) => {
    const titleId = useFormId('dialog-title');
    let figure = null;
    if (imgSrc) {
        figure = (
            <aside className={classes.figure}>
                <img alt="" className={classes.image} src={imgSrc} />
            </aside>
        );
    }
    return (
        <Dialog
            classes={{
                root:  classes.root,
                paper: className
            }}
            PaperProps={isMultiColumn ? {
                style: {
                    maxWidth: 1000
                }
            } : {}}
            open={open}
            onClose={onClose}
            onEnter={onRendered}
            scroll="paper"
            aria-labelledby={titleId}
            disableBackdropClick={disableBackdropClick}
            disableEscapeKeyDown={disableEscapeKeyDown}
        >
            <DialogTitle
                id={titleId}
                classes={{
                    root: classes.header
                }}
                disableTypography
            >
                {title}
                {cancelable ?
                    <IconButton
                        aria-label="Close"
                        classes={{
                            root: classes.closeButton
                        }}
                        color="inherit"
                        onClick={onClose}
                    >
                        <i className="fa fa-times" />
                    </IconButton>
                    : null }
            </DialogTitle>
            <DialogContent
                classes={{
                    root: classes.dialogContent
                }}
            >
                <ActionErrorList errors={errors} />
                <div className={classes.body}>
                    {figure}
                    <section className={isMultiColumn ? classes.multiColumnContent : classes.bodyContent}>
                        {children}
                    </section>
                </div>
            </DialogContent>
            {
                !hideButtons &&
                <DialogActions
                    classes={{
                        root: classes.dialogActions
                    }}
                >
                    <CancelButton
                        hidden={!cancelable}
                        cancel={onClose}
                    />
                    <ConfirmButton
                        disabled={disabled}
                        form={confirmFormId}
                        isLoading={isLoading}
                        label={confirmText}
                        onClick={onConfirm}
                        type={confirmType}
                    />
                </DialogActions>
            }
        </Dialog>
    );
};

EsmsDialog.defaultProps = {
    cancelable:    true,
    confirmText:   'Create',
    disabled:      false,
    errors:        [],
    isMultiColumn: false,
    onClose:       () => {},
    onConfirm:     () => {}
};

EsmsDialog.propTypes = {
    cancelable:    bool,
    children:      node,
    confirmFormId: string,
    confirmText:   string,
    confirmType:   oneOf(['button', 'submit']),
    disabled:      bool,
    errors:        array,
    isLoading:     bool,
    isMultiColumn: bool,
    onClose:       func,
    onConfirm:     func,
    open:          bool,
    render:        func,
    title:         string.isRequired
};

export default EsmsDialog;
